onLoad(($) => {
  const nodes = $('.JS-change-options-by-select');

  if (!nodes.length) return;

  const refreshFields = function(select) {
    const selectsData = select.dataset.selects;

    // Verificar se `data-selects` existe e é válido
    if (!selectsData) return;

    let selects;
    try {
      selects = JSON.parse(selectsData);
    } catch {
      return; // Ignorar erro de JSON inválido
    }

    const selected = $(select).children('option:selected').val();

    // Esconder todos os campos inicialmente
    Object.keys(selects).forEach(key => {
      showOrHidden(selects[key], false);
    });

    // Mostrar os campos correspondentes à seleção atual
    if (selected && selects[selected]) {
      showOrHidden(selects[selected], true);
    }
  };

  const showOrHidden = function(changable, show) {
    if (!changable) return;

    const keys = Object.keys(changable);

    keys.forEach(key => {
      const field = $(`#${key}`);
      const elements = changable[key];

      field.empty();

      if (show === true) {
        elements.forEach(element => {
          field.append($("<option></option>").attr("value", element[1]).text(element[0]));
        });

        field.trigger('change');
      }
    });
  };

  // Adicionar evento de mudança para cada elemento
  nodes.change(function() {
    refreshFields(this);
  });

  // Atualizar todos os campos no carregamento
  nodes.each((_, node) => refreshFields(node));
});
